/** When a related-doc number click should open the mini preview (plan/45). */

export function shouldOpenRelatedDocPreview(
  e: {
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
    altKey: boolean;
    button: number;
  },
  compact: boolean,
): boolean {
  if (compact) return false;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
    return false;
  }
  return true;
}
